import { createRouter, createWebHashHistory, RouteRecordRaw, createWebHistory } from 'vue-router'
//pc路由出口
import Fist from "../view/pc/first/first.vue"
//移动端路由出口
import mobile from "../view/mobile/mof.vue"
const ISMOBILE = function () {
    const pageWidth = window.innerWidth;
    if (pageWidth <= 700) {
        return pageWidth;
    }
    // let flag = navigator.userAgent.match(
    //     /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    // );
}
// 定义PC端路由数组
const routesPC: Array<RouteRecordRaw> = [
    //全匹配
    {
        path: "/",
        // 重定向
        redirect: "/First"
    },
    {
        path: "/First",
        component: Fist,
        redirect: "/Home",
        children: [
            {
                path: '/Home',
                meta: { title: "Home", },
                component: () => import('@/view/pc/home/home.vue')
            },
            {
                path: '/GameDetails/:gid',
                meta: { title: "GameDetails", },
                component: () => import('@/view/pc/GameDetails/GameDetails.vue')
            },
            {
                path: '/Message',
                meta: { title: "Message", },
                component: () => import('@/view/pc/Message/Message.vue')
            },
            {
                path: '/ClassificationDetails/:id/:name',
                meta: { title: "ClassificationDetails", },
                component: () => import('@/view/pc/ClassificationDetails/ClassificationDetails.vue')
            },
            {
                path: '/Search/:keyword',
                // path: '/Search',
                meta: { title: "Search", },
                component: () => import('@/view/pc/Search/Search.vue')
            },
            {
                path: '/Categories/:name',
                meta: { title: "Categories", },
                component: () => import('@/view/pc/Categories/Categories.vue')
            },
            
        ]
    },
]
// 定义移动端路由数组
const routesM: Array<RouteRecordRaw> = [
    //全匹配
    {
        path: "/",
        // 重定向
        redirect: "/mobile"
    },
    {
        path: "/mobile",
        component: mobile,
        redirect: "/Home",
        children: [
            {
                path: '/Home',
                component: () => import('@/view/mobile/home/Home.vue')
            },
            {
                path: '/Categories/:name',
                meta: { title: "Categories", },
                component: () => import('@/view/mobile/Categories/Categories.vue')
            },
            {
                path: '/ClassificationDetails/:id/:name',
                meta: { title: "ClassificationDetails", },
                component: () => import('@/view/mobile/ClassificationDetails/ClassificationDetails.vue')
            },
            {
                path: '/Search/:keyword',
                meta: { title: "Search", },
                component: () => import('@/view/mobile/Search/Search.vue')
            },
            {
                path: '/GameDetails/:gid',
                meta: { title: "GameDetails", },
                component: () => import('@/view/mobile/GameDetails/GameDetails.vue')
            },
            {
                path: '/Message',
                meta: { title: "Message", },
                component: () => import('@/view/mobile/Message/Message.vue')
            },
        ]
    },
    {
        path: '/About',
        meta: { title: "About", },
        component: () => import('@/view/mobile/ifreme.vue')
    },
]
// 创建一个路由实例对象
const router = createRouter({
    history: createWebHistory(),
    routes: ISMOBILE() ? routesM : routesPC,
})
// 导出创建好的实例对象
export default router